export const INITIAL_ITEM_MENU = {
  visible: false,
  rateId: -1,
  visibleTooltip: false,
};